<div>
    <mat-card appearance="outlined" class="greeting-card">
        <mat-card-content>
            <h3 style="color: #000;">{{ greeting }} <b>{{ loggedInUserName }}</b></h3>
            <p style="color: #000;">{{ quoteText }}</p>
        </mat-card-content>
    </mat-card>
    <ng-container *ngIf="userRole === 'ROLE_ADMIN' || userRole === 'ROLE_JE' || userRole === 'ROLE_AGE' || userRole === 'ROLE_GE' || userRole === 'ROLE_CE' || userRole === 'ROLE_ZS'">
        <app-metrics-dashboard></app-metrics-dashboard>
    </ng-container>
    <!-- <ng-container *ngIf="userRole === 'ROLE_ADMIN'">
        <app-manage-user-requests></app-manage-user-requests>
    </ng-container> -->
    <ng-container *ngIf="userRole === 'ROLE_USER'">
        <app-user-dashboard></app-user-dashboard>
    </ng-container>
</div>
